import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyBAm72ocKXlebNtwBZ9mDwm2fswXDaGrws",
  authDomain: "aira-auth-37eba.firebaseapp.com",
  projectId: "aira-auth-37eba",
  storageBucket: "aira-auth-37eba.firebasestorage.app",
  messagingSenderId: "926702173765",
  appId: "1:926702173765:web:5959b14bcc8027f3292d2c",
  measurementId: "G-ZJ2TY7XSF6"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider()

export default app
